//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import { convertTime } from '../../components/helpers.js'
import ReportExecutor from './ReportExecutor.vue'
import ReportImages from './ReportImages.vue'

export default {
  components: {
    ReportExecutor,
    ReportImages
  },
  provide: function () {
    return { reportContentEnabled: false }
  },
  props: {
    report: {
      type: Object,
      default () {
        return {}
      }
    },
    expandPhoto: { // не реактивное
      type: Boolean,
      default: false
    },
    external: {
      type: Boolean,
      default: false
    },
    searchText: {
      type: String,
      default: null
    },
    searchFields: {
      type: Array,
      default: null
    }
  },
  data: function () {
    return {
      expansionPhotos: this.expandPhoto,
      imgFilesNumber: 0,

      convertTime: convertTime
    }
  },
  computed: {
    requestId: function () {
      return this.report.requestId[this.report.id]
    },
    href: function () {
      return '/task/' + this.requestId + '/document/' + this.report.id
    },
    applicantDescr () {
      if (this.searchText && this.searchFields && this.searchFields.includes('applicantDescr')) {
        return this.getHighlightHTMLText(this.searchText, this.report.applicantDescr)
      }
      return this.report.applicantDescr
    },
    comment () {
      if (this.searchText && this.searchFields && this.searchFields.includes('commonWorkComment')) {
        return this.getHighlightHTMLText(this.searchText, this.report.comment)
      }
      return this.report.comment
    }
  },
  methods: {
    getHighlightHTMLText: function (searchText, text) {
      const searchRegex = new RegExp(`(${this.escapeRegExp(searchText)})`, 'gi')
      return text && text.replace(searchRegex, '<mark>$1</mark>')
    },
    escapeRegExp: function (string) {
      return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
    },
    openTask: function () {
      this.$router.push(this.href)
    },
    onOpenLink: function (id) {
      const href = 'https://delta.spetsdor.ru/index.php?r=act%2Fview&id=' + id
      window.open(href, '_blank')
    },
    onUpdateFilesNumber: function (filesNumber, type) {
      this.$nextTick(() => {
        // this[type + 'Number'] = filesNumber // imgFilesNumber, docFilesNumber
        this.imgFilesNumber = filesNumber
      })
    }
  }
}

